import { render, staticRenderFns } from "./_resourceRatio.vue?vue&type=template&id=39552514&scoped=true"
import script from "./_resourceRatio.vue?vue&type=script&lang=js"
export * from "./_resourceRatio.vue?vue&type=script&lang=js"
import style0 from "./_resourceRatio.vue?vue&type=style&index=0&id=39552514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39552514",
  null
  
)

export default component.exports